<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmitWarningForm(data)" appFocusFirstElement>
  <h2
    class="text-start"
    mat-dialog-title
    style="margin-bottom: 0px !important;">
    {{(data?.label ? (data.label | translate) : 'alert.confirm') | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>

  <div class="row pt-1 mx-0" *ngIf="data?.message" style="margin: unset!important;overflow: hidden!important;">
    <div class="col-2 text-center" style="margin: auto; color: #ff0000;">
      <em class="fa fa-warning text-primary fa-3x"></em>
    </div>
    <div class="col-10 pl-0">
      <div [innerHTML]="data?.message | translate"
           style="font-size: medium; overflow-wrap: break-word;"></div>
    </div>
  </div>
  <div *ngIf="data.reason!=null" class="row mt-2" style="margin-left: unset!important;overflow: hidden!important;margin-right: unset!important">
      <mat-form-field >
        <mat-label>
          {{(data?.reasonLabel ? (data?.reasonLabel |translate): 'form.reason') | translate}}
        </mat-label>
        <textarea
          (focusout)="data.reason = data?.reason.trim()"
          name="reason"
          #focusInput
          matInput
          maxlength='250'
          #name="ngModel"
          [(ngModel)]="data.reason"
          [required]="data.required"
          style='max-height: 50vh; min-height: 10vh'></textarea>
        <mat-error>
          {{'validation.reason'| translate}}
        </mat-error>
      </mat-form-field>
  </div>



  <div mat-dialog-actions class="justify-content-center">

    <!--build icon, set default cancel-->
    <button mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial>
      <mat-icon class="mr-0">cancel</mat-icon>
      {{(data?.cancelLabel ? (data?.cancelLabel |translate): 'button.ignore') | translate}}
    </button>
    <button
      mat-raised-button
      class="ml-2"
      color="primary" type="submit" style="color: white;">
      <mat-icon class="mr-0">done</mat-icon>
      {{(data?.acceptLabel ? (data?.acceptLabel |translate): 'button.accept') | translate}}
    </button>
  </div>
</form>
